export default __webpack_public_path__ + "static/media/elite crown 2.e979cd06.svg";